import { LockOutlined } from '@ant-design/icons';
import { AccessRequestLink } from 'components/shared/AccessRequestLink';
import { parseGroupAndAction } from 'helpers/accessErrors/helpers';
import React from 'react';

/** Dispatched on `window` when code outside React (e.g. axios) needs a permission-denied notification with Apollo hooks in the description. */
export const ACCESS_FORBIDDEN_NOTIFICATION_EVENT = 'oms-access-forbidden';

export interface AccessErrorNotificationMeta {
  group?: string;
  permission?: string;
}

export interface AccessForbiddenNotificationDetail {
  message: string;
  meta?: AccessErrorNotificationMeta;
}

interface AccessErrorNotificationBuildParams {
  message: string;
  group?: string;
  action?: string;
}

export const resolvePermissionDeniedNotificationParams = (
  message: string,
  meta?: AccessErrorNotificationMeta,
): AccessErrorNotificationBuildParams => {
  const parsed = parseGroupAndAction(message);

  return {
    message,
    group: meta?.group ?? parsed?.group,
    action: meta?.permission ?? parsed?.action,
  };
};

export const buildPermissionDeniedNotificationArgs = ({
  message,
  group,
  action,
}: AccessErrorNotificationBuildParams) => {
  return {
    message,
    description: <AccessRequestLink group={group} action={action} />,
    duration: 15,
    icon: <LockOutlined style={{ color: '#ff4d4f' }} />,
    style: { border: '2px solid #ff4d4f' },
  };
};

export const accessErrorNotification = (message = "You don't have permissions", meta?: AccessErrorNotificationMeta) => {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<AccessForbiddenNotificationDetail>(ACCESS_FORBIDDEN_NOTIFICATION_EVENT, {
      detail: { message, meta },
    }),
  );
};
